import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
// import { HealthComponent } from '@xiam/xiam-ui-toolkit'
import { HealthCheckWidget } from '@xiam/xiam-ui-toolkit'
import styles from './Health.module.scss'
import { useIsMobileView } from '../../utils/isMobileView'
import '@xiam/xiam-ui-toolkit/dist/xiam-ui-toolkit.css'

function Health({ t, status, healthCheck, healthRows, handleRefresh, refresh, error, healthType }) {
  const isMobileView = useIsMobileView()
  const [healthCheckSharedValues, setHealthCheckSharedValues] = useState({})

  useEffect(() => {
    const values = {
      idp: healthCheck.idpStatus === 'healthy' || healthCheck?.status === 'active',
      status,
      uptime: healthCheck.uptime,
      error: error || ''
    }

    setHealthCheckSharedValues(values)
  }, [status, healthCheck])

  const leftAlignStyle = {
    textAlign: 'left',
    fontFamily: "'JohnsonDisplay', Arial",
    marginLeft: '100px',
    marginTop: '45px',
    width: '85vw',
  }

  const leftAlignStyleMobile = {
    textAlign: 'left',
    fontFamily: "'JohnsonDisplay', Arial",
    marginLeft: '50px',
    marginTop: '80px',
  }

  return (
    <div style={isMobileView ? leftAlignStyleMobile : leftAlignStyle}>
      { healthType === 'general' && <h1 className={styles.headTitle}>{t('healthHeader')}</h1> }
      <h1 className={styles.headName}>{healthType === 'general' ? t('health-api-header') : t('health-bulk-api-header')}</h1>
      <hr className={styles.topLine} />
      <HealthCheckWidget
        healthCheck={healthCheckSharedValues}
        handleRefresh={handleRefresh}
        healthRows={healthRows}
        refresh={refresh}
        status={status}
        error={error}
      />
    </div>
  )
}

Health.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  refresh: PropTypes.bool.isRequired,
  healthType: PropTypes.bool.isRequired,
  healthCheck: PropTypes.shape({
    status: PropTypes.bool,
    uptime: PropTypes.string,
    idpStatus: PropTypes.string,
  }).isRequired,
  healthRows: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    key: PropTypes.string,
    value: PropTypes.string,
  })).isRequired,
}

export default Health
